import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type PropsWithChildren } from 'react'

const styles = stylex.create({
  root: {
    backgroundColor: colors.grey100,
    minHeight: 'calc(100vh - 56px)',
  },
})

export const AiPurchaseOrderPageShell = ({ children }: PropsWithChildren) => (
  <div {...stylex.props(styles.root)}>{children}</div>
)
